@if (routes && routes.length > 0) {
<mat-nav-list class="pt-0">
  @for (route of routes; track route; let i = $index) {
  <mat-list-item
    #rla="routerLinkActive"
    [disabled]="route.disabled$ ? (route.disabled$() | async) : false"
    [id]="route.htmlId"
    [ngClass]="route.classes"
    [queryParams]="route.queryParams"
    [routerLinkActiveOptions]="{ exact: false }"
    [routerLink]="route.disabled$ && (route.disabled$() | async) ? null : route.url"
    [title]="route.label | transloco"
    routerLinkActive="active"
  >
    <div [ngClass]="['flex items-center', route.icon ? 'gap-2' : '']" matListItemTitle>
      @if (route.icon) {
      <mat-icon matListItemIcon>{{ route.icon }}</mat-icon>
      } @if (expanded) {
      <div>
        <div>{{ route.label | transloco }}</div>
        @if (route.sublabel) {
        <div class="text-sm leading-none text-gray-400">
          {{ route.sublabel }}
        </div>
        }
      </div>
      }
    </div>
    @if (route.deletable) {
    <button
      (click)="removeRoute.emit([$event, route])"
      mat-icon-button
      [title]="'ui.buttons.close' | transloco"
      matListItemMeta
    >
      <mat-icon>close</mat-icon>
    </button>
    }
  </mat-list-item>
  }
</mat-nav-list>
}
